import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store/'



import gradeLogin from "@/view/login";
import loginPrint from "@/view/loginPrint";
let routes =  [
  {
    path: "/",
    name: "gradeLogin",
    component: gradeLogin,
    meta:{
      title: "登录",
    }
  },
  {
    path: "/gradeLogin",
    name: "gradeLogin",
    component: gradeLogin,
    meta:{
      title: "登录",
    }
  },{
    path: "/loginPrint",
    name: "loginPrint",
    component: loginPrint,
    meta:{
      title: "登录",
    }
  },
];
Vue.use(Router);

let vueRouter = new Router({routes});
export default vueRouter;


// WEBPACK FOOTER //
// ./src/router/index.js